import React, { useState } from 'react';
import styles from './sign-up-form.module.scss';
import { DefaultButton, FormButtonBack, FormInput } from 'shared/ui';
import { MailConfirmationInput, signUpOwner } from 'features';
import { validateSignUpForm } from '../model/validate-sign-up-form';
import { Link, useNavigate } from 'react-router-dom';
import { AppLinks } from 'app/router/consts/app-links.enum';
import { VerificationCodeEnum } from 'shared/types';

export const SignUpForm: React.FC = () => {
  const [fio, setFio] = useState('');
  const [email, setMail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [isDataConsentAccepted, setIsDataConsentAccepted] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async () => {
    const errors = validateSignUpForm(
      fio,
      email,
      phone,
      password,
      confirmPassword,
      isTermsAccepted,
      isDataConsentAccepted
    );
    if (!errors) {
      try {
        await signUpOwner(email, fio.trim(), phone, password);
        navigate(AppLinks.SignInLink);
      } catch (error) {
        if (error instanceof Error) {
          setError(error.message);
        }
      }
    } else {
      setError(errors);
    }
  };

  return (
    <div className={styles.sign_up}>
      <div className={styles.sign_up__content}>
        <div className={styles.sign_up__title}>Регистрация</div>
        <div className={styles.sign_up__inputs}>
          <div className={styles.inputs__input}>
            <FormInput
              inputTitle="ФИО"
              inputPlaceholder="Фамилия Имя Отчество"
              onChange={(value) => {
                setFio(value);
              }}
            />
          </div>
          <div className={styles.inputs__input}>
            <MailConfirmationInput
              onChange={(value) => {
                setMail(value);
              }}
              type={VerificationCodeEnum.EMAIL_VERIFICATION}
            />
          </div>
          <div className={styles.inputs__input}>
            <FormInput
              isPhone={true}
              inputTitle="Номер телефона"
              onChange={(value) => {
                setPhone(value.match(/\d+/g)?.join('') ?? '');
              }}
            />
          </div>
          <div className={styles.inputs__input}>
            <FormInput
              inputType="password"
              showPasswordToggle
              inputTitle="Пароль"
              inputPlaceholder="Пароль"
              onChange={(value) => {
                setPassword(value);
              }}
            />
            <div className={styles.inputs__password_hint}>
              от 8 до 16 символов
            </div>
          </div>
          <div className={styles.inputs__input}>
            <FormInput
              inputType="password"
              showPasswordToggle
              inputTitle="Повторите пароль"
              inputPlaceholder="Пароль"
              onChange={(value) => {
                setConfirmPassword(value);
              }}
            />
          </div>
        </div>
        <div className={styles.sign_up__checkboxes}>
          <label className={styles.inputs__checkbox_label}>
            <input
              type="checkbox"
              checked={isTermsAccepted}
              onChange={(e) => setIsTermsAccepted(e.target.checked)}
            />
            <span>
              Принимаю{' '}
              <Link
                to="/terms-of-service"
                className={styles.inputs__checkbox_link}
              >
                Пользовательское соглашение
              </Link>
            </span>
          </label>
          <label className={styles.inputs__checkbox_label}>
            <input
              type="checkbox"
              checked={isDataConsentAccepted}
              onChange={(e) => setIsDataConsentAccepted(e.target.checked)}
            />
            <span>
              Согласен(на) на{' '}
              <Link
                to="/privacy-policy"
                className={styles.inputs__checkbox_link}
              >
                обработку персональных данных
              </Link>{' '}
              в соответствии с{' '}
              <Link
                to="/privacy-policy"
                className={styles.inputs__checkbox_link}
              >
                Политикой конфиденциальности
              </Link>
            </span>
          </label>
        </div>
        <div className={styles.sign_up__buttons}>
          <div className={styles.buttons__error}>{error}</div>
          <div className={styles.buttons__button_submit} onClick={handleSubmit}>
            <DefaultButton buttonText="Зарегистрироваться" color="white" />
          </div>
          <div className={styles.buttons__button_back}>
            <FormButtonBack />
          </div>
        </div>
      </div>
    </div>
  );
};
